export const mainResponse = [
  {
    type: "Inflow",
    info: [
      {
        name: "Lease receipt",
        datas: {
          "Oct-25": 860426,
          "Nov-25": 904056,
          "Dec-25": 902589,
          "Jan-26": 910014,
          "Feb-26": 945024,
          "Mar-26": 1095920,
          "Apr-26": 1242733,
          "May-26": 1375351,
          "Jun-26": 1240166,
          "Jul-26": 1166402,
          "Aug-26": 1101740,
          "Sep-26": 1146139,
        },
      },
      {
        name: "Retail receipt",
        datas: {
          "Oct-25": 3229147,
          "Nov-25": 3141772,
          "Dec-25": 3152939,
          "Jan-26": 3127658,
          "Feb-26": 3119559,
          "Mar-26": 3155277,
          "Apr-26": 3106843,
          "May-26": 3118902,
          "Jun-26": 3098218,
          "Jul-26": 3106383,
          "Aug-26": 3084247,
          "Sep-26": 3087098,
        },
      },
      {
        name: "Wholesale receipt",
        datas: {
          "Oct-25": 7141709,
          "Nov-25": 4144858,
          "Dec-25": 3823240,
          "Jan-26": 3993734,
          "Feb-26": 3793210,
          "Mar-26": 4106741,
          "Apr-26": 4046849,
          "May-26": 4094385,
          "Jun-26": 4193735,
          "Jul-26": 4208274,
          "Aug-26": 4053710,
          "Sep-26": 4234511,
        },
      },
      {
        name: "Other finance receipt",
        datas: {
          "Oct-25": 841516,
          "Nov-25": 839560,
          "Dec-25": 890173,
          "Jan-26": 847934,
          "Feb-26": 797875,
          "Mar-26": 842327,
          "Apr-26": 849072,
          "May-26": 864321,
          "Jun-26": 845677,
          "Jul-26": 862478,
          "Aug-26": 866182,
          "Sep-26": 851683,
        },
      },
      {
        name: "Non-finance receipt",
        datas: {
          "Oct-25": 0,
          "Nov-25": 0,
          "Dec-25": 0,
          "Jan-26": 0,
          "Feb-26": 0,
          "Mar-26": 0,
          "Apr-26": 0,
          "May-26": 200000,
          "Jun-26": 0,
          "Jul-26": 25000,
          "Aug-26": 250000,
          "Sep-26": 0,
        },
      },
    ],
  },
  {
    type: "Outflow",
    info: [
      {
        name: "Personnel cost",
        datas: {
          "Oct-25": 0,
          "Nov-25": 0,
          "Dec-25": 0,
          "Jan-26": 0,
          "Feb-26": 0,
          "Mar-26": 0,
          "Apr-26": 0,
          "May-26": 0,
          "Jun-26": 0,
          "Jul-26": 0,
          "Aug-26": 0,
          "Sep-26": 0,
        },
      },
      {
        name: "Other costs & expenditures",
        datas: {
          "Oct-25": -214620,
          "Nov-25": -195800,
          "Dec-25": -227703,
          "Jan-26": -227820,
          "Feb-26": -1680125,
          "Mar-26": -264753,
          "Apr-26": -231344,
          "May-26": -231351,
          "Jun-26": -231362,
          "Jul-26": -599391,
          "Aug-26": -231410,
          "Sep-26": -331390,
        },
      },
      {
        name: "Interest Expense",
        datas: {
          "Oct-25": -443026,
          "Nov-25": -437211,
          "Dec-25": -448586,
          "Jan-26": -446695,
          "Feb-26": -409021,
          "Mar-26": -453983,
          "Apr-26": -433459,
          "May-26": -444888,
          "Jun-26": -429223,
          "Jul-26": -440481,
          "Aug-26": -441291,
          "Sep-26": -430579,
        },
      },
      {
        name: "Maturing CP",
        datas: {
          "Oct-25": -2848000,
          "Nov-25": -2505322,
          "Dec-25": -2292054,
          "Jan-26": -2251043,
          "Feb-26": -2242719,
          "Mar-26": -1488711,
          "Apr-26": -1243743,
          "May-26": -1674606,
          "Jun-26": -922883,
          "Jul-26": 0,
          "Aug-26": 0,
          "Sep-26": 0,
        },
      },
      {
        name: "Debt Service (TMFNL)",
        datas: {
          "Oct-25": 0,
          "Nov-25": 0,
          "Dec-25": 0,
          "Jan-26": 0,
          "Feb-26": 0,
          "Mar-26": 0,
          "Apr-26": 0,
          "May-26": 0,
          "Jun-26": 0,
          "Jul-26": 0,
          "Aug-26": 0,
          "Sep-26": 0,
        },
      },
      {
        name: "Debt Service (Other TFS Group)",
        datas: {
          "Oct-25": 0,
          "Nov-25": 0,
          "Dec-25": 0,
          "Jan-26": 0,
          "Feb-26": 0,
          "Mar-26": 0,
          "Apr-26": 0,
          "May-26": 0,
          "Jun-26": 0,
          "Jul-26": 0,
          "Aug-26": 0,
          "Sep-26": 0,
        },
      },
      {
        name: "Debt Service (Other)",
        datas: {
          "Oct-25": -3023348,
          "Nov-25": -2026739,
          "Dec-25": -3502073,
          "Jan-26": -4147223,
          "Feb-26": -5894397,
          "Mar-26": -1221027,
          "Apr-26": -2206537,
          "May-26": -4351653,
          "Jun-26": -2319817,
          "Jul-26": -2636314,
          "Aug-26": -4767543,
          "Sep-26": -1093629,
        },
      },
      {
        name: "New Lease",
        datas: {
          "Oct-25": -1226223,
          "Nov-25": -1135402,
          "Dec-25": -1094566,
          "Jan-26": -1086266,
          "Feb-26": -988460,
          "Mar-26": -1139598,
          "Apr-26": -1245227,
          "May-26": -1116160,
          "Jun-26": -1177239,
          "Jul-26": -1203054,
          "Aug-26": -1445262,
          "Sep-26": -1368169,
        },
      },
      {
        name: "New Retail",
        datas: {
          "Oct-25": -3253056,
          "Nov-25": -3060902,
          "Dec-25": -2859786,
          "Jan-26": -2829161,
          "Feb-26": -2616654,
          "Mar-26": -3050330,
          "Apr-26": -3140375,
          "May-26": -2865893,
          "Jun-26": -2991481,
          "Jul-26": -3034521,
          "Aug-26": -3583002,
          "Sep-26": -3501261,
        },
      },
      {
        name: "New Wholesale",
        datas: {
          "Oct-25": -7898574,
          "Nov-25": -4358819,
          "Dec-25": -3532062,
          "Jan-26": -4275990,
          "Feb-26": -3885784,
          "Mar-26": -3912297,
          "Apr-26": -4231672,
          "May-26": -4140289,
          "Jun-26": -4315084,
          "Jul-26": -4189808,
          "Aug-26": -4172062,
          "Sep-26": -4256969,
        },
      },
      {
        name: "New Other",
        datas: {
          "Oct-25": -50000,
          "Nov-25": 0,
          "Dec-25": -400000,
          "Jan-26": 0,
          "Feb-26": -200000,
          "Mar-26": -400000,
          "Apr-26": -290000,
          "May-26": 0,
          "Jun-26": 0,
          "Jul-26": 0,
          "Aug-26": 0,
          "Sep-26": 0,
        },
      },
      {
        name: "CSA Volatility (1 Month)",
        datas: {
          "Oct-25": -704000,
          "Nov-25": 0,
          "Dec-25": 0,
          "Jan-26": 0,
          "Feb-26": 0,
          "Mar-26": 0,
          "Apr-26": 0,
          "May-26": 0,
          "Jun-26": 0,
          "Jul-26": 0,
          "Aug-26": 0,
          "Sep-26": 0,
        },
      },
      {
        name: "RDN Holdback",
        datas: {
          "Oct-25": -328353,
          "Nov-25": 0,
          "Dec-25": 0,
          "Jan-26": 0,
          "Feb-26": 0,
          "Mar-26": 0,
          "Apr-26": 0,
          "May-26": 0,
          "Jun-26": 0,
          "Jul-26": 0,
          "Aug-26": 0,
          "Sep-26": 0,
        },
      },
    ],
  },
  {
    type: "Total Liquidity Investment + SLRM",
    info: [
      {
        name: "Total Liquidity Investment + SLRM",
        datas: {
          "Oct-25": 14511265,
          "Nov-25": 14511265,
          "Dec-25": 14511265,
          "Jan-26": 14511265,
          "Feb-26": 14511265,
          "Mar-26": 14511265,
          "Apr-26": 14511265,
          "May-26": 14511265,
          "Jun-26": 14511265,
          "Jul-26": 14511265,
          "Aug-26": 14511265,
          "Sep-26": 14511265,
        },
      },
    ],
  },
];

export const investments = [
  {
    name: "Cash & Deposits",
    value: 3400200,
  },
  {
    name: "MMK & Gov Inv.",
    value: 5171763,
  },
  {
    name: "Other",
    value: 939302,
  },
];

export const commercialPaper = [
  {
    name: "Unutilized Capacity",
    value: 19870882,
  },
];

export const creditFacilityResponse = [
  {
    creditFacility: "Committed Group Loan Fcty (as a Lender) [Deduction]",
    facility: -1000000,
    utilized: 0,
  },
  {
    creditFacility: "Committed Conduit Facility (TRAC)",
    facility: 9000000,
    utilized: 4348667,
  },
  {
    creditFacility: "SLRM",
    facility: 5000000,
    utilized: 0,
  },
  {
    creditFacility: "Committed Bilateral BK Fcty",
    facility: 4095000,
    utilized: 0,
  },
  {
    creditFacility: "Committed Syndicated BK Fcty",
    facility: 10289000,
    utilized: 0,
  },
];

export const stReceivablesOnBs = [
  {
    receivablesName: "Lease",
    receivablesValue: 11911954,
  },
  {
    receivablesName: "Retail",
    receivablesValue: 33641270,
  },
  {
    receivablesName: "Wholesale",
    receivablesValue: 13871296,
  },
  {
    receivablesName: "Other Financial",
    receivablesValue: 475000,
  },
  {
    receivablesName: "",
    receivablesValue: "",
  },
  {
    receivablesName: "",
    receivablesValue: "",
  },
];
export const stLiabilitiesOnBs = [
  {
    liabilitiesName: "Commercial Paper",
    liabilitiesValue: 17469081,
  },
  {
    liabilitiesName: "Bank Debt",
    liabilitiesValue: 0,
  },
  {
    liabilitiesName: "Bonds",
    liabilitiesValue: 37190297,
  },
  {
    liabilitiesName: "Other S/T Debts",
    liabilitiesValue: 0,
  },
  {
    liabilitiesName: "",
    liabilitiesValue: "",
  },
  {
    liabilitiesName: "",
    liabilitiesValue: "",
  },
];

export const HARDCODED_MINIMUM_CASH_BUFER = 2032353;
export const HARDCODED_AVG_ACTUAL_CASH_BUFFER = 10086340;
